import { useState } from 'react';
import { cn } from '@/lib/utils';
import { useOrg } from '../OrgProvider';
import { ApiKeysPanel } from '../components/ApiKeysPanel';
import { MembersPanel } from '../components/MembersPanel';
import { CiConfigPanel } from '../components/CiConfigPanel';
import { OrgStoragePanel } from '../components/OrgStoragePanel';

type Tab = 'keys' | 'members' | 'ci' | 'storage';

export function OrgSettingsPage() {
  const { activeOrg } = useOrg();
  const [tab, setTab] = useState<Tab>('keys');

  if (!activeOrg) {
    return (
      <div className="py-16 text-center">
        <h2 className="text-lg font-semibold text-ink">No organization selected</h2>
        <p className="mt-1 text-sm text-dim">
          Select or create an organization to manage settings.
        </p>
      </div>
    );
  }

  const tabs: { key: Tab; label: string }[] = [
    { key: 'keys', label: 'API Keys' },
    { key: 'members', label: 'Members' },
    { key: 'ci', label: 'CI' },
    { key: 'storage', label: 'Storage' },
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-lg font-semibold text-ink">{activeOrg.name}</h1>
        <p className="text-sm text-dim">Manage your organization settings</p>
      </div>

      <nav className="flex items-center gap-1 border-b border-rule">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={cn(
              '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              tab === t.key
                ? 'border-accent text-accent'
                : 'border-transparent text-dim hover:text-ink'
            )}
          >
            {t.label}
          </button>
        ))}
      </nav>

      {tab === 'keys' && <ApiKeysPanel />}
      {tab === 'members' && <MembersPanel />}
      {tab === 'ci' && <CiConfigPanel />}
      {tab === 'storage' && <OrgStoragePanel />}
    </div>
  );
}
